module.exports = __webpack_public_path__ + "img/crosses-bg.e0a701ff.png";